<template>
	<div class="box">

		<ComSearch @doSearch="doSearch" @changePosition="changePosition"></ComSearch>

		<div class="process-image-div">
			<img class="process-image" src="../assets/shop_flow_bg.jpg" />
		</div>

		<ComShopList :shopList="filterShopList" :shopListCtx="shopListCtx" @refresh="refreshShop"></ComShopList>

	</div>
</template>

<script>
	import ComSearch from '../components/searchShop/ComSearch.vue'
	import ComShopList from '../components/searchShop/ComShopList.vue'
	import {
		getStarShop,
		getStarbucksStore
	} from '@/request/api';
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex";
	import {
		Notify
	} from 'vant';
	export default {
		name: 'searchShop',
		computed: mapGetters(["sLocation"]),
		components: {
			[ComShopList.name]: ComShopList,
			[ComSearch.name]: ComSearch,
			[Notify.name]: Notify
		},
		created() {
			this.searchShop()
		},
		data() {
			return {
				searchKey: '',
				shopListCtx:"加载中",
				radius: 5000,
				pageSize: 20,
				pageIndex: 1,
				shopList: [],
				filterShopList:[],
				count: 0
			}
		},
		methods: {
			changePosition(res){
				console.log("casdkjfl",res,'change');
				if(this.sLocation.lng && this.sLocation.lat){
					return
				}else{
					this.searchShop(res[0],res[1])
				}
			},
			searchShop(lat,lng) {
				console.log(this.sLocation.lng,this.sLocation.lat,'定位信息',lat,lng);
				if ((!this.sLocation.lng) && !lng ) {
					return
				}
				// let params = {};
				// if (this.sLocation.lat && this.sLocation.lng) {
				// 	params.keyword = '星巴克' + this.searchKey;
				// 	params.boundary = 'nearby(' + this.sLocation.lat + ',' + this.sLocation.lng + ',' + this.radius + ')';
				// 	params.filter = 'category=娱乐休闲,咖啡厅';
				// 	params.orderby = '_distance';
				// 	params.page_size = this.pageSize;
				// 	params.page_index = this.pageIndex;
				// 	params.key = this.$enum.CONSTANT.TX_KEY;
				// 	params.output = 'jsonp';
				// } else {
				// 	params.keyword = '星巴克' + this.searchKey;
				// 	params.boundary = 'region(' + this.sLocation.city + ',' + 0 + ')';
				// 	params.filter = 'category=娱乐休闲,咖啡厅';
				// 	params.page_size = this.pageSize;
				// 	params.page_index = this.pageIndex;
				// 	params.key = this.$enum.CONSTANT.TX_KEY;
				// 	params.output = 'jsonp';
				// }
				getStarbucksStore({
					latitude: this.sLocation.lat || lat,
					longitude: this.sLocation.lng || lng,
				}).then(res => {
					this.shopList = [];
					if (res) {
						for (let item of res) {
							this.shopList.push({
								shopName: item.name,
								shopLocation: item.address,
								lat: item.location.split(",")[0],
								lng: item.location.split(",")[1],
								distance: item.distance,
								storeId:item.id
							});
						}
						this.filterShopList = JSON.parse(JSON.stringify(this.shopList));
						if(this.filterShopList.length==0){
							this.shopListCtx = "暂无门店"
						}
					}
				})

				return;
			},
			doSearch(searchName) {
				this.pageIndex = 1;
				this.radius = 5000;
				this.searchKey = searchName;
				this.filterShopList = [];
				let arr = JSON.parse(JSON.stringify(this.shopList));
				// console.log(arr)
				if(this.searchKey.trim()){
					this.filterShopList = arr.filter((p)=>(p.shopName.indexOf(this.searchKey)!==-1))
				}else{
					this.filterShopList = arr;
				}
				// console.log(this.filterShopList,arr)
				// this.searchShop();
			},
			refreshShop() {
				this.pageIndex++;
				if (this.count <= this.pageSize * this.size) {
					this.radius = this.radius + this.radius;
				}
				// this.searchShop();
			}
		}
	}
</script>

<style scoped>
	.box {
		width: 100%;
		height: 100%;
		background-color: #f5f5f5;
	}



	.process-image-div {
		padding: 10px 15px;
	}

	.process-image-div>img {
		width: 100%;
		height: 110px;
	}
</style>
